import { Type } from '@angular/core';
import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';


export class BriefingChartDimensionsFieldModel implements FormFieldModel {

    fieldComponent?: Type<AbstractFormFieldComponent>;
    property: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property
    }
}
